import { render, staticRenderFns } from "./product_preview.vue?vue&type=template&id=6c9eefce&scoped=true&"
import script from "./product_preview.vue?vue&type=script&lang=js&"
export * from "./product_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9eefce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c9eefce')) {
      api.createRecord('6c9eefce', component.options)
    } else {
      api.reload('6c9eefce', component.options)
    }
    module.hot.accept("./product_preview.vue?vue&type=template&id=6c9eefce&scoped=true&", function () {
      api.rerender('6c9eefce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/preview/product_preview.vue"
export default component.exports